// ClassAttributeExtension.js
import { Extension } from '@tiptap/core'

export const ClassAttribute = Extension.create({
  name: 'class-attribute',

  addGlobalAttributes() {
    const types = this.extensions.map((ext) => ext.name).filter(name => name !== 'text');

    return [
      {
        types: types,
        attributes: {
          class: {
            default: null,
            parseHTML: element => element.getAttribute('class'),
            renderHTML: attributes =>
              attributes.class ? { class: attributes.class } : {},
          },
          style: {
            default: null,
            parseHTML: element => element.getAttribute('style'),
            renderHTML: attributes =>
              attributes.style ? { style: attributes.style } : {},
          },
        },
      },
    ]
  },
})